export const service_data=[{
    id:'0',
    category:'智慧',
    title:'智慧水务整体解决方案',
    cont:'通过在线远传监测设备采集数据、通过物联网技术及互联网技术传输数据、通过大数据技术及云计算技术理解、联想、辨别、计算、分析、判断，达到为指导水务企业生产、经营、服务、管理提供决策和支持的目标。',
    addClass:'green',
},{
    id:'1',
    category:'降差',
    title:'降低产销差解决方案',
    cont:'在已建立DBS分区的基础上，实现对各个级别的DBS区域进行产销差率实时监测和预警，并实现对各个DBS区域的在线漏损指标分析计算，从而控制供水管网的产销差率，使之逐步降低，逐步稳定到最佳水平。',
    addClass:'orange',
},{
    id:'2',
    category:'安全',
    title:'安全供水解决方案',
    cont:'为保障供水系统水量、水压及水质的安全性，通过建立供水管网水力模型，评价管网运行健康状态，制定管网改扩建方案、监测点优化布置方案、管网DBS分区方案、管网水锤防护方案、管网事故应急方案等。',
    addClass:'blue-white',
}]